import PolicyTenantIdsField from './PolicyTenantIdsField'

export default PolicyTenantIdsField
